import '@fontsource/manrope/400.css'
import '@fontsource/manrope/500.css'
import '@fontsource/manrope/600.css'
import '@fontsource/manrope/700.css'

import './styles.css'
import './iconly/style.css'

export const colors = {
    primary: '#2772FF',
    primaryGradient: 'linear-gradient(275.12deg, #04ECFD -46.59%, #2772FF 109.3%)',
    orange: '#FCBB4C',
    red: '#FF274B',
    green: '#20D193',
    green2: '#68ADBA',

    black: '#1B1F27',
    text: '#69707E',
    white: '#FFFFFF',

    grey: '#BCC6D9',
    grey2: '#A8B0C0',
    line: '#EBF0F9',
    lightBlue: '#F5F9FF',

    link: '#6198FF',

}
